import React, {useState} from 'react'
import FieldDropdown from '../FieldDropdown'
import { exportExcel } from '../../lib/excel'
import { useCreateReplace, useDeleteDocument } from '../../hooks/mutations'
import { keyId, addValueForDropdown, copyId, errorAlert, addNameSwal, successAlert} from '../../lib/utils'
import VisDiv from '../frontend_components/VisDiv'
import { useStateContext } from '../../context/StateContext'
import { ManageDocumentReferenceInOtherDocuments, ReferenceCheckList } from './ManagementModules'
import { StepByStepProgress } from './StepByStepProgress'
import {Divider, SliderRegistriTemplates, TextField, ViewLabelValueField} from '../../components'
import TrueFalseToggle from '../TrueFalseToggle'
import { richEditorDoc, referenceDoc } from '../gestioneDatabase/Docs'
import { v4 as uuidv4 } from 'uuid';
import RichTextEditor from '../RichTextEditor'
import {FiCopy } from 'react-icons/fi'
import { useQueryClient } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { _FETCH } from '../../lib/patches'
import { useAuthContext } from '../../hooks/useAuthContext'
import { useManagementContext } from '../../context/ManagementContext'
import TestButton from '../frontend_components/TestButton'
import NoAccessMessage from '../NoAccessMessage'
import Swal from 'sweetalert2'
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle } from "react-icons/io";



/**
 * NonConformitiesManagement component
 * 
 * This component is used to manage non conformities documents.
 * It renders a StepByStepProgress component with a progress list.
 * Each item in the progress list is a component that is used to manage a specific part of the non conformity document.
 * The component also renders buttons to save or reset the document.
 * 
 * #registerManagement 
 * #offerManagament
 * 
 * @param {Object} props The props object passed to the component.
 * @param {string} props.queryKey The query key to use to fetch the data from the cache.
 * @param {Object} props.data The data object passed to the component.
 * 
 * @returns {React.Component} The NonConformitiesManagement component.
 */

const NonConformitiesManagement = ({queryKey=['nonConformitiesManagement'], data={}}) => {
    
    const queryClient = useQueryClient()
    const {nonConformities, customerProducts, templateRegister, deviceProperties, presidioModules, templateRegisters, dataModules, lists, hideCloseButton} = data

/*     const {mutate: createNonConformity} = useCreateReplace({
        onError:(e)=>{
            console.log("Non Conformity Not Added", e)
            errorAlert("La non conformità non è stata aggiunta, riprovare")
        }}) */

    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: queryKey })
            const previousData = queryClient.getQueryData(queryKey)
       
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(queryKey, (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData }
        },

        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            errorAlert("Errore: il documento non é stato aggiornato")
        },
            onSuccess: (data, variables) => {
                successAlert("NON CONFORMITA' AGGIORNATA CON SUCCESSO")
                setNewNonConformityEdited(false)
            }
        })


    const {customer, sUser} = useStateContext()
    const {newNonConformity, setNewNonConformity, newNonConformityEdited, setNewNonConformityEdited} = useManagementContext()
    
   /*  const [viewDatabaseList, setViewDatabaseList] = useState(false); */

    //const [selectedNonConf, setSelectedNonConf] = useState(undefined)

 

    // **************** ------- IMPORTA NON CONFORMITA A REGISTRO DA ARRAY --------- *************

/*        const arrayNonConformita = []

       const nonConformitaPresenti = !templateRegister ? 
       (!Array.isArray(nonConformities) ? [] : nonConformities?.filter?.(x=>arrayNonConformita.some?.((y=>y==x.label)))) : 
       (!Array.isArray(nonConformities) ? [] : nonConformities.filter?.(x=>arrayNonConformita.some?.((y=>y==x.label))))
       .filter?.(x=>x?.registers?.some?.(z=>z?._ref == templateRegister?._id))
       const registerId = templateRegister?._id
       
       const arrayOggetti = arrayNonConformita.filter?.((x)=> !nonConformitaPresenti?.some?.((y)=>y?.label == x))?.map?.((item)=>{
         const isSign = (text) => {
           if(text.includes("CARTELLO")) return true
           if(text.includes("KIT")) return true
           return false
         } 
         return {
           label: item,
           _type: "nonConformity",
           registers: [{
             _ref: registerId,
             _type: "reference",
             _key: keyId()
           }],
           customer: {
             _ref: "cef60f4c-fe70-43e1-8fa2-caa77dc35634",
             _type: "reference",
             _key: keyId()
           },
           isSign: isSign(item)
     
     
         }
       })

       const createNonConformities = () => {
        if(!templateRegister) {console.log("ADD REGISTER")} 
        else {
          arrayOggetti.forEach((x)=>{
            setTimeout(createNonConformity({doc:x}),5000)
            console.log(x)
            
          } )
        }
      } */
      // ______________________________________________________________________________//


      const customerId = customer?._id ? customer?._id : sUser?.customer?._ref
        const save = (data, bypassEdit) => {
          setNewNonConformity(data)
           if(!bypassEdit){setNewNonConformityEdited(true)}
          //updateDocument({doc: data})
          console.log("SAVE PRESIDIO DOC:", data)
      }
          const updateDatabase = async(doc) => {
                 await updateDocument({doc: doc})
      
          }
      
              const resetDoc = async() => {
                  if(newNonConformityEdited){
                      const result = await Swal.fire({
            
                          title: 'Documento Non Salvato',
                          text: 'Vuoi uscire ugualmente? i dati andranno persi.',
                          icon: 'error',
                          showCancelButton: true,
                          confirmButtonText: 'Chiudi Documento',
                          cancelButtonText: 'Annulla'
                      });
                  
                      if (result.isConfirmed) {
                          // Fall back to mailto
                          setNewNonConformity(undefined)
                          setNewNonConformityEdited(false)
                      }
                  } else {
                      setNewNonConformity(undefined)
                      setNewNonConformityEdited(false)
                  }
                        
                }
                const archive = async () => {
                  const archivedDoc = {...newNonConformity, status:"ARCHIVIATO"}
                  console.log("ARCHIVIA", archivedDoc)
                  // Update cache first
                  await updateDocument({doc: archivedDoc});
                  // Then update local state
                  setNewNonConformity(archivedDoc);
                  setNewNonConformityEdited(false)
              }
              const restore = async () => {
                  const restoredDoc = {...newNonConformity, status:"ATTIVO"}
                  console.log("ATTIVA", restoredDoc)
                  // Update cache first
                  await updateDocument({doc: restoredDoc});
                  // Then update local state
                  setNewNonConformity(restoredDoc);
                  setNewNonConformityEdited(false)
              }

      const templateRegistersReferenceData = {type: "referenceArray", hideFilter:true, data: templateRegisters, propertyName: "registers"}
      const assetsReferenceData = {type: "referenceArray", hideFilter:true, data: presidioModules, propertyName: "devices", templates: templateRegisters}
      const propertiesReferenceData = {type: "referenceArray", hideFilter:true, data: deviceProperties, propertyName: "deviceProperties", templates: templateRegisters, lists, dataModules}
  
      const progressList = [
        {description: "NOME NON CONFORMITA'", component: <NonConformityName doc={newNonConformity} setDoc={save} data={{}}/>},
        {description: "ASSEGNA TIPOLOGIE REGISTRO", component: <AssignRegisterTemplates doc={newNonConformity} setDoc={save} data={{referenceData: templateRegistersReferenceData}}/>},
        {description: "ASSEGNA PRESIDI", component: <AssignAssets doc={newNonConformity} setDoc={save} data={{referenceData: assetsReferenceData}}/>},
        {description: "ASSEGNA PROPRIETA'", component: <AssignProperties doc={newNonConformity} setDoc={save} data={{referenceData: propertiesReferenceData}}/>},
        {description: "IMPOSTAZIONI", component: <NonConformitySettings doc={newNonConformity} setDoc={save} />},
        {description: "DESCRIZIONE PER PRODOTTO", component: <DescriptionForProduct doc={newNonConformity} setDoc={save} data={{}}/> },
        {description: "PRODOTTI ASSEGNATI", component: <AssignedCustomersProducts doc={newNonConformity} setDoc={save} data={{customerProducts}} />},

        
      ]


/*       const onNonConformityClick = (item) => {
        console.log("templateRegister", templateRegister)
        //console.log("devices:", devices?.filter?.(x=>x?.deviceNonConformities?.some?.(y=>y?.nonConformity?._ref == item._id )))
        //setSelectedNonConf(item)
        console.log(item)
       } */


       const consoleData = {
        supplyNonConf: nonConformities?.filter?.((x)=>x?.supply),
        nonConformities,
        newNonConformity
       }

       if(sUser?.userType !== "God Mode" && sUser?.userType !== "Admin"){
            return <NoAccessMessage/>  

} 
        if (!customerId){return <p>Customer not found</p>}

       return (
            <div style={{overflow:"auto", height:"88vh", paddingBottom:"100px" }}> 
{/*                 <VisDiv rules={[templateRegister && arrayNonConformita?.length > 0]}>
                    <button style={{marginBottom:"10px", backgroundColor:"green"}}className='blue-button' onClick={createNonConformities}>AGGIUNGI NON CONF DA ARRAY</button>  
                </VisDiv> */}
            <h2>GESTIONE NON CONFORMITA'</h2>
            <TestButton buttonId='opkpqokopwk' message='TEST MANAGE NON CONF' consoleData={consoleData}/>
            <div style={{display: "flex", alignItems:"center"}}>
                <VisDiv style={{marginBottom:"10px", marginRight:"10px"}} rules={[newNonConformity]}>
                    <button onClick={resetDoc} className={"pdf-button"}>CHIUDI DOCUMENTO</button>
                </VisDiv>
                <VisDiv style={{marginRight:"10px", marginBottom:"10px",}}  rules={[newNonConformity]}>
                    <button type="button" disabled={!newNonConformityEdited} style={{backgroundColor: newNonConformityEdited ? "green" : "grey"}} className="pdf-button" onClick={()=>updateDatabase(newNonConformity)} >
                        {"SALVA DOCUMENTO"}
                    </button>
                </VisDiv>
                <VisDiv style={{marginBottom:"10px", marginRight:"10px"}}  rules={[newNonConformity && newNonConformity?.status !== "ARCHIVIATO"]}>
                    <button type="button" style={{backgroundColor: "red"}} className="pdf-button" onClick={()=>archive()} >
                        {"ARCHIVIA"}
                    </button>
                </VisDiv>
                <VisDiv style={{marginBottom:"10px", marginRight:"10px"}}  rules={[newNonConformity?.status == "ARCHIVIATO"]}>
                    <button type="button" style={{backgroundColor: "green"}} className="pdf-button" onClick={()=>restore()} >
                        {"RIPRISTINA"}
                    </button>
                </VisDiv>
            </div>

            <VisDiv rules={[newNonConformity?.label]} style={{textAlign:"center"}}>
                <h2>NON CONFORMITA': {newNonConformity?.label}</h2>
            </VisDiv>
                <VisDiv rules={[!newNonConformity]}>
                    <AddOrEditNonConformity updateDatabase={updateDatabase} doc={newNonConformity} setDoc={save} data={{...data}}/>
                </VisDiv>
                <VisDiv rules={[newNonConformity]}>
                    <StepByStepProgress progressList={progressList}/>
                </VisDiv>

            </div>
  )
}

export default NonConformitiesManagement

export const DatabaseNonConformityPin = ({data={}}) => {
    const {nonConformity} = data
    const {mutate: deleteDevice} = useDeleteDocument({
        onError:(e)=>{
            console.log("Device not Deleted", e);
            errorAlert("Errore, il presidio non é stato eliminato")
        }})

    return(                        
    <div style={{borderRadius:"10px",border:"2px solid grey", padding:"10px", marginBottom:"5px"}}>
        <div onClick={()=>{onNonConformityClick(nonConformity)}} 
            style={{padding:"10px"}} >{nonConformity?.label}</div>
        <div style={{display:"flex"}}>
            <button className='red-button' onClick={()=>deleteDevice({documentId: nonConformity?._id })}>ELIMINA</button>
            <a className='red-button' style={{marginLeft:"5px", backgroundColor:"blue"}} target="_blank" href={`http://localhost:3333/desk/nonConformity;${nonConformity?._id}`} >MODIFICA</a>
        </div>
    </div>)
}

export const AddOrEditNonConformity = ({updateDatabase, doc, setDoc, data={}}) => { 
    
    const {customer} = useStateContext()
    const [nonConformityName, setNonConformityName] = useState("")
    const [selectedNonConformity, setSelectedNonConformity] = useState("")
    const {nonConformities, templateRegisters, presidioModules, deviceProperties, lists, dataModules, laws, products, suppliers, priceLists} = data 
    const [nonConformityFilter, setNonConformityFilter] = useState({label:"ATTIVI", value: "ATTIVI"})
    const [viewEmpty, setEmpty] = useState(false)
    const [viewFilterFamily, setViewFilterFamily] = useState(false)
    const [templateRegister, setTemplateRegister] = useState()
    const nonConformityFilters = [
            {label:"ATTIVI", value: "ATTIVI"},
            {label:"ARCHIVIATI", value: "ARCHIVIATI"},
            {label:"FORNITURA", value: "FORNITURA"},
            {label:"SOSTITUZIONE", value: "SOSTITUZIONE"},
            {label:"SCADENZA", value: "SCADENZA"},
            {label:"GENERATA", value: "GENERATA"},
            {label:"NOTIFICA (GRAVE)", value: "NOTIFICA (GRAVE)"},
            {label:"CARTELLO", value: "CARTELLO"},
            {label:"MULTI", value: "MULTI"},
        ]

    const nonConformitiesList = () => {
        const emptyNonConformities = !Array.isArray(nonConformities) ? [] : nonConformities?.filter?.((x)=>x?.registers?.some?.(y=>!y?._ref)) 
        
        const filterByRegister = (item) => {
            if (templateRegister) return item?.registers?.some?.(y=>y?._ref == templateRegister?._id) 
            return item
          }
          const filterByType = (item) => {
            if (nonConformityFilter?.value == "ATTIVI") return item?.status !== "ARCHIVIATO"
            if (nonConformityFilter?.value == "ARCHIVIATI") return item?.status == "ARCHIVIATO"
            if (nonConformityFilter?.value == "FORNITURA") return item?.supply == true
            if (nonConformityFilter?.value == "SOSTITUZIONE") return item?.deadlineSubstitutionIfClientRevisionFalse == true
            if (nonConformityFilter?.value == "SCADENZA") return item?.deadline == true
            if (nonConformityFilter?.value == "GENERATA") return item?.fieldGenerated == true
            if (nonConformityFilter?.value == "NOTIFICA (GRAVE)") return item?.notification == true
            if (nonConformityFilter?.value == "CARTELLO") return item?.isSign == true
            if (nonConformityFilter?.value == "MULTI") return item?.multi == true
            return item
          }

        if(!templateRegister && viewEmpty) {return emptyNonConformities}

        return nonConformities
            .filter?.((y => filterByRegister(y) ))
            .filter?.((x)=>filterByType(x))
        
       }
    
        // **************** ------- EXPORT EXCEL --------- *************


    const nonConformitiesListExport = () => (
        nonConformitiesList()?.map?.((item)=>{
          return(
            {
              label: item?.label,
              _id: item?._id,
              _type: item?._type,
              templates: item?.registers?.map?.(x=>x._ref).toString(),
              notification: item?.notification
            }
          )
        })
       )

    const duplicateDoc = () => ({
        ...selectedNonConformity, 
        label: nonConformityName, 
        _id: uuidv4(), 
        _key: keyId(),
    })

    const emptyDoc = () => ({
        _type: "nonConformity",
        _id: uuidv4(),
        _key: keyId(),
        label: "",
        customer: referenceDoc(customer?._id),
        registers: [],
        devices: [],
        devicesExclude:false,
        deviceProperties: [],
        propertiesExclude: false,
        details: richEditorDoc(""),
        deadline: false,
        deadlineSubstitutionIfClientRevisionFalse: false,
        notification: false,
        informative: false,
        supply: false,
        substitution: false,
        isSign: false,
        fieldGenerated: false,
        multi: false,
    })

    const labelValueDistance = 5

    const selectedProductData = [
        {label: "NOME", value: selectedNonConformity?.label},
        {label: "REGISTRI", value: selectedNonConformity?.registers?.map?.((item)=>!Array.isArray(templateRegisters) ? undefined : templateRegisters?.find?.((x)=>x?._id == item?._ref)?.family)?.toString()},
        {highlight: "green", value: selectedNonConformity?.devicesExclude && "ESCLUDE PRESIDI"},
        {label: "PRESIDI", value: selectedNonConformity?.devices?.map?.((item)=> !Array.isArray(presidioModules) ? undefined : presidioModules?.find?.((x)=>x?._id == item?._ref)?.label)?.toString()},
        {highlight: "green", value: selectedNonConformity?.propertiesExclude && "ESCLUDE PROPRIETA'"},
        {label: "PROPRIETA'", value: selectedNonConformity?.deviceProperties?.map?.((item)=> !Array.isArray(deviceProperties) ? undefined : deviceProperties?.find?.((x)=>x?._id == item?._ref)?.label)?.toString()},
        {label: "DESCRIZIONE PER PRODOTTO", value: selectedNonConformity?.details?.blocks?.map?.((x)=>x?.text)?.toString()},
        {highlight: "green", value: selectedNonConformity?.deadline && "SCADENZA"},
        {highlight: "green", value: selectedNonConformity?.supply && "FORNITURA"},
        {highlight: "green", value: selectedNonConformity?.substitution && "SOSTITUZIONE"},
        {highlight: "green", value: selectedNonConformity?.informative && "INFORMATIVA"},
        {highlight: "amber", value: selectedNonConformity?.deadlineSubstitutionIfClientRevisionFalse && "SOSTITUZIONE REVISIONE"},
        {highlight: "amber", value: selectedNonConformity?.multi && "MULTI-RISPOSTA"},
        {highlight: "red", value: selectedNonConformity?.fieldGenerated && "GENERATA DA UN CAMPO PRESIDIO"},
        {highlight: "amber", value: selectedNonConformity?.isSign && "CARTELLO"},

    ]
    
 const createNewEmptyDoc = () => {
          const okFn = (name) => {
            const docToSave = emptyDoc()
              setDoc({...docToSave, label: name})
              updateDatabase({...docToSave, label: name})
              setNonConformityName(name)
          }
          addNameSwal({docType:"NON CONFORMITA'", okFn})   
           
  }
    const duplicateExistingDoc = () => {
        const checks = () => {
            if(duplicateDoc()?.law?._id) return false
            if(duplicateDoc()?.supplierProducts?.some?.((x)=>x?._id)) return false
            return true
        }
        if(!checks()){
            errorAlert("Il prodotto non è stato duplicato, ricaricare e riprovare")
            return
        }

          const okFn = (name) => {
              const docToSave = duplicateDoc()
              setDoc({...docToSave, label: name})
              updateDatabase({...docToSave, label: name})
              setNonConformityName(name)
              //console.log("skdaòsldkasòldk", {docToSave, selectedNonConformity, duplicateDoc: duplicateDoc(), name})
          }
          addNameSwal({docType:"NON CONFORMITA'", okFn})  
    }
    const editExistingDoc = () => {
        setDoc(selectedNonConformity, true)
    }
    return (
    <div>
        <VisDiv style={{marginLeft:"10px"}} rules={[true]}>
            <button style={{marginBottom:"10px", backgroundColor:"green"}}className='blue-button' onClick={()=>exportExcel(nonConformitiesListExport(),"DATA EXPORT NON CONF")}>ESPORTA EXCEL</button>   
        </VisDiv>
        <div style={{marginBottom :"10px",display:"flex", cursor:"pointer", alignItems:"center"}} onClick={() => setViewFilterFamily(!viewFilterFamily)}>
            <h4>FILTRA PER FAMIGLIA:</h4>
            {viewFilterFamily ? <IoIosArrowDropupCircle size={25}/> : <IoIosArrowDropdownCircle size={25}/>}
        </div>
        <VisDiv rules={[viewFilterFamily]}>
                <SliderRegistriTemplates 
                    registerTemplateFilter={templateRegister} 
                    setRegisterTemplateFilter={setTemplateRegister} 
                    templates={!Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>x?.customer?._ref == customer?._id)} 
                    //setLoading={setLoading}
                />
        </VisDiv>   
        <h3>SELEZIONA FILTRO:</h3>
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={nonConformityFilter}
            placeHolder="Filtra Per Tipologia"
            options={nonConformityFilters}
            onChange={(value) => {setNonConformityFilter(value)
        }}
        />
         <Divider />
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            //initialValue={expandSupplier(supplierProduct?.supplier)}
            placeHolder={"SELEZIONA NON CONFORMITA' ESISTENTE"}
            options={addValueForDropdown(nonConformitiesList())}
            onChange={(value) => { 
                setSelectedNonConformity(value)
            }}
        />
  
        <div style={{display:"flex", justifyContent:"space-evenly"}}>
            <VisDiv rules={[]}>
                <button className="pdf-button" onClick={createNewEmptyDoc} >INSERISCI VUOTO</button>
            </VisDiv>
            <VisDiv rules={[selectedNonConformity]}> 
                <button className="pdf-button" onClick={editExistingDoc} >MODIFICA NON CONFORMITA' ESISTENTE</button>
            </VisDiv>
            <VisDiv rules={[selectedNonConformity]}>
                <button className="pdf-button" onClick={duplicateExistingDoc} >DUPLICA NON CONFORMITA' </button>
            </VisDiv>
        </div>
        <VisDiv rules={[selectedNonConformity]}>
            <Divider/>
            {selectedProductData?.map?.((item,index)=>{
                return(
                    <VisDiv key={index} rules={[item?.value]}>
                        <ViewLabelValueField 
                            label={item?.label} 
                            value={item?.value}
                            labelValueDistance={labelValueDistance}
                            highlight={item?.highlight}
                        />
                    </VisDiv>
                )
            })}

        </VisDiv>
    </div>
)}
//=======================================================================================

export const NonConformityName = ({doc, setDoc, data}) => { 
    
    return (
    <div>
        <TextField 
            value={doc?.label} 
            onChange={(e) => setDoc({...doc, label: e.target.value})} 
            description={"Questo dato non sarà inserito nell'offerta, serve per trovare la non conformità"} 
            descriptionDivider={false}
        />
        <div style={{display:"flex", marginTop:"10px", alignItems:"center"}}>
            <button type='button' className='round-back-button' style={{backgroundColor: "#324d67", marginRight:"10px"}} onClick={()=>copyId(doc)}>
                <FiCopy            
                size={15}
                color={"white"}/>
            </button>
            <h3>COPIA ID A CLIPBOARD</h3>

        </div>

    </div>
)}

export const AssignNonConformities = ({doc, setDoc, data}) => { 
    
    const {referenceData} = data
    return <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
}

//=======================================================================================

export const AssignRegisterTemplates = ({doc, setDoc, data}) => { 

    const {referenceData} = data
    return <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
    
}
//=======================================================================================

export const AssignAssets = ({doc, setDoc, data}) => { 
    
    const {referenceData} = data
    return (
    <div>
        <TrueFalseToggle 
            value={doc?.devicesExclude}
            onClick={()=>setDoc({...doc, devicesExclude: !doc?.devicesExclude})}
            label={"ESCLUDI PRESIDI"} 
            description={"Selezionare questa opzione se si vuole escludere i presidi selezionati invece di includerli. "}
        />
        <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
    </div>
    
)}

//=======================================================================================
export const AssignProperties = ({doc, setDoc, data}) => { 
    
    const {referenceData} = data
    return (
    <div>       
        <TrueFalseToggle 
            value={doc?.propertiesExclude}
            onClick={()=>setDoc({...doc, propertiesExclude: !doc?.propertiesExclude})}
            label={"ESCLUDI PROPRIETA'"} 
            description={"Selezionare questa opzione se si vuole escludere le proprietà selezionate invece di includerle. "}
        />
        <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
    </div>
    
)}

//=======================================================================================


export const NonConformitySettings = ({doc, setDoc, data}) => { 

    return (
    <div style={{marginTop:"10px"}}>

        <TrueFalseToggle 
            value={doc?.isSign}
            onClick={()=>setDoc({...doc, isSign: !doc?.isSign})}
            label={"CARTELLO"} 
            description={"Selezionare questa opzione se questa non conformità è un cartello"}
        />
        <TrueFalseToggle 
            value={doc?.supply}
            onClick={()=>setDoc({...doc, supply: !doc?.supply})}
            label={"FORNITURA"} 
            description={"Selezionare questa opzione solo se questa non conformità è legato ad una fornitura di un presidio"}
        />
        <TrueFalseToggle 
            value={doc?.substitution}
            onClick={()=>setDoc({...doc, substitution: !doc?.substitution})}
            label={"SOSTITUZIONE"} 
            description={"Selezionare questa opzione solo se questa non conformità è una scadenza e genera una sostituzione"}
        />
        <TrueFalseToggle 
            value={doc?.deadlineSubstitutionIfClientRevisionFalse}
            onClick={()=>setDoc({...doc, deadlineSubstitutionIfClientRevisionFalse: !doc?.deadlineSubstitutionIfClientRevisionFalse})}
            label={"SOSTITUZIONE"} 
            description={"Selezionare questa opzione solo se questa non conformità è una scadenza e genera una sostituzione quando il cliente non ha la revisione selezionata"}
        />
        
        <TrueFalseToggle 
            value={doc?.notification}
            onClick={()=>setDoc({...doc, notification: !doc?.notification})}
            label={"NOTIFICA GRAVE"} 
            description={"Selezionare questa opzione solo se questa non conformità è grave. In questo caso verrà inclusa nelle notofiche che vengono spedite al cliente via PEC."}
        />
{/*         <TrueFalseToggle 
            value={doc?.multi}
            onClick={()=>setDoc({...doc, multi: !doc?.multi})}
            label={"MULTI"} 
            description={"Questa non conformità può essere selezionata più volte"}
        /> */}
             <TrueFalseToggle 
            value={doc?.fieldGenerated}
            onClick={()=>setDoc({...doc, fieldGenerated: !doc?.fieldGenerated})}
            label={"GENERATA DA UN CAMPO PRESIDIO"} 
            description={"Questa non conformità viene generata da un campo del presidio e non compare nella lista delle non conformità. Per essere attiva deve essere assegnata ad un campo presidio in un modello registro"}
        />
        <TrueFalseToggle 
            value={doc?.informative}
            onClick={()=>setDoc({...doc, informative: !doc?.informative})}
            label={"INFORMATIVO"} 
            description={"Questa non conformità è a titolo informativo e non genera uno o più prodotti nell'offerta"}
        />

    </div>
)}

//=======================================================================================

const DescriptionForProduct = ({doc, setDoc, data}) => {

    const [value, setValue] = useState(doc)
    const editorDocDescription = (data) => {
        //console.log("EDITOR DOC", data)
        const newValue = {...value, details: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        setValue(newValue)
        //setDoc(newValue)
        //setLaws([...filteredArray, newValue])
        

    }
    const saveDescription = () => {
       //const newValue = {...value, details: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
       //console.log("EDITOR BLUR", value)
       setDoc(value)
    } 
    return(

        <VisDiv style={{display:"flex", padding: "10px"}}>
            <VisDiv rules={[true]} style={{flex:1.5, padding: "10px"}}> 
                <h4>DESCRIZIONE</h4>
                <RichTextEditor onBlur={saveDescription} noFocus={true} existingDoc={doc?.details} readOnly={false} editorDoc={editorDocDescription}/>
            </VisDiv>
        </VisDiv>
    )
}

export const AssignedCustomersProducts = ({doc, data}) => {
    const {apiUrl} = useStateContext()
    const fetchRoute = `${apiUrl}/calls/fetch-docs`
    const {user} = useAuthContext()
    const {customerProducts} = data



    const testFunction = () => {
        console.log("TEST ASSIGNED", doc)
    }
    return ( 
        <div>
            <button onClick={testFunction}>test prodotti assegnati</button>
            <ManageDocumentReferenceInOtherDocuments 
                doc={doc} 
                query = {['customerProductsReport']}
                data={{
                    targetArray: customerProducts,
                    referenceArrayNameinTargetDocument: "nonConformities",

                    }
                }
            />
        </div>
         );
}
 
